<template>
<input v-if="invisible"
       ref="file"
       type="file"
       :data-lpignore="!lastpass"
       style="display: none !important;"
       :accept="accept"
       @focus="$emit('focus')"
       @blur="$emit('blur')"
       @change="change">
<div v-else
     class="odr-upload__dummy"
     :class="{
         'odr-upload__dummy_ondrag': ondrag,
         'odr-upload__dummy_file': file,
     }"
     :style="`width: ${width}px !important; \
                  height: ${height}px !important;`">
    <input ref="file"
           type="file"
           :data-lpignore="!lastpass"
           class="odr-upload__input"
           :accept="accept"
           @focus="$emit('focus')"
           @blur="$emit('blur')"
           @change="change">
    <div class="odr-upload__dummy-icon">
        <icon size="l" color="default">{{ icon }}</icon>
    </div>
    <div v-if="file" class="odr-upload__filename">
        {{ file.name }}
    </div>
</div>
</template>

<script>
export default {
    props: {
        invisible: {},
        width: {},
        height: {},
        lastpass: {},
        accept: {},
        icon: {},
        input: {},
    },
    data () {
        return {
            ondrag: false,
            file: null,
        };
    },
    watch: {
        input () {
            if (!this.input) {
                this.file = null;
            }
        },
    },
    mounted () {
        this.$refs.file.addEventListener('dragleave', () => { this.ondrag = false; });
        this.$refs.file.addEventListener('dragover', () => { this.ondrag = true; });
        this.$refs.file.addEventListener('drop', () => { this.ondrag = false; });
    },
    methods: {
        change () {
            let file = this.$refs.file.files[0];

            let reader = new FileReader();

            reader.onloadend = () => {
                this.$emit('changed', { result: reader.result, filename: file.name });
            };

            if (file) {
                reader.readAsDataURL(file);
                this.file = file;
            } else {
                this.file = null;
            }
        },
    },
    components: {
        icon: require('@clearwave/odoro-markup/lib/vue/icon.vue').default,
    },
};
</script>
